var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.011,
    height: 25.545,
    viewBox: "0 0 20.011 25.545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14192",
    "data-name": "Trazado 14192",
    d: "M48.6,0H32.842V25.545H52.853V4.257Z",
    transform: "translate(-32.842)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14193",
    "data-name": "Trazado 14193",
    d: "M93.33,58.9c-.307-.547-1.368-.719-1.854-.8a7.377,7.377,0,0,0-1.163-.079c-.3,0-.6.013-.9.03-.109.007-.217.017-.325.026q-.166-.172-.321-.354a11.77,11.77,0,0,1-1.624-2.584,10.2,10.2,0,0,0,.263-1.389,5.8,5.8,0,0,0-.193-2.717c-.114-.289-.417-.641-.766-.466-.4.2-.515.773-.548,1.177a3.928,3.928,0,0,0,.047.977,6.974,6.974,0,0,0,.244.939q.137.422.3.838c-.07.218-.144.432-.222.641-.181.475-.377.927-.566,1.362l-.292.632a21.433,21.433,0,0,1-1,1.94,10.876,10.876,0,0,0-2.263,1.064,4.948,4.948,0,0,0-.9.725,1.578,1.578,0,0,0-.5.929.586.586,0,0,0,.233.517.976.976,0,0,0,.792.1,4.32,4.32,0,0,0,2.092-1.549,17.052,17.052,0,0,0,1.295-1.64l0,0a19.6,19.6,0,0,1,2.576-.607c.419-.07.849-.126,1.288-.166a6.07,6.07,0,0,0,1.006.772,4.621,4.621,0,0,0,.9.431,6.45,6.45,0,0,0,.971.243,2.859,2.859,0,0,0,.513.028c.39-.015.95-.164.987-.638A.661.661,0,0,0,93.33,58.9Zm-9.341.869c-.183.283-.359.538-.525.762a3.772,3.772,0,0,1-1.544,1.456,1.194,1.194,0,0,1-.473.084c-.158-.009-.314-.079-.306-.258a.758.758,0,0,1,.12-.331,2.046,2.046,0,0,1,.276-.356,4.58,4.58,0,0,1,.824-.667,9.759,9.759,0,0,1,1.742-.867C84.064,59.653,84.026,59.713,83.989,59.77Zm2.294-7.1a3.215,3.215,0,0,1-.027-.885,2.094,2.094,0,0,1,.087-.417c.036-.112.114-.386.238-.421.2-.058.268.382.291.506a5.571,5.571,0,0,1-.143,2.188c-.025.11-.053.219-.082.327-.049-.135-.1-.27-.139-.406A6.655,6.655,0,0,1,86.282,52.671Zm1.406,5.584a19.926,19.926,0,0,0-2.189.481,5.615,5.615,0,0,0,.546-.889A10.836,10.836,0,0,0,87,55.64a10.777,10.777,0,0,0,1.529,2.293q.085.095.173.187C88.359,58.157,88.02,58.2,87.688,58.255Zm5.2.985c-.028.152-.353.239-.5.263a2.89,2.89,0,0,1-1.35-.13,4.327,4.327,0,0,1-.847-.395,5.028,5.028,0,0,1-.753-.562c.289-.017.581-.029.875-.023a7.407,7.407,0,0,1,.883.056,3.12,3.12,0,0,1,1.6.605C92.873,59.125,92.9,59.187,92.89,59.24Z",
    transform: "translate(-76.717 -46.269)",
    fill: "#fb3449"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14194",
    "data-name": "Trazado 14194",
    d: "M49.255,2.129H32.842V0H48.6Z",
    transform: "translate(-32.842)",
    fill: "#fb3449"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467",
    transform: "translate(4.986 19.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14195",
    "data-name": "Trazado 14195",
    d: "M94.956,227.178a1.353,1.353,0,0,1-.4,1.047,1.612,1.612,0,0,1-1.135.369h-.307v1.341H92.022v-4.042h1.4a1.71,1.71,0,0,1,1.15.335A1.193,1.193,0,0,1,94.956,227.178Zm-1.841.525h.2a.544.544,0,0,0,.391-.138.5.5,0,0,0,.145-.382q0-.409-.453-.409h-.282Z",
    transform: "translate(-92.022 -225.892)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14196",
    "data-name": "Trazado 14196",
    d: "M137.919,227.827a2.089,2.089,0,0,1-.557,1.559,2.14,2.14,0,0,1-1.566.547h-1.308v-4.042h1.4a2.111,2.111,0,0,1,1.5.5A1.879,1.879,0,0,1,137.919,227.827Zm-1.134.039a1.285,1.285,0,0,0-.22-.824.813.813,0,0,0-.668-.268h-.318v2.264h.243a.881.881,0,0,0,.73-.289A1.4,1.4,0,0,0,136.786,227.866Z",
    transform: "translate(-130.91 -225.892)",
    fill: "#a4a9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14197",
    "data-name": "Trazado 14197",
    d: "M184.889,229.934h-1.076v-4.042H186.2v.877h-1.313v.771H186.1v.877h-1.211v1.518Z",
    transform: "translate(-176.079 -225.892)",
    fill: "#a4a9ad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14198",
    "data-name": "Trazado 14198",
    d: "M219.821,4.257h4.257L219.821,0Z",
    transform: "translate(-204.067)",
    fill: "#d1d3d3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ec1b723cea24ba3e0aea881de9cc4fe7.svg";
export { ForwardRef as ReactComponent };